import { render, staticRenderFns } from "./Covid.vue?vue&type=template&id=9bdf6730&"
import script from "./Covid.vue?vue&type=script&lang=js&"
export * from "./Covid.vue?vue&type=script&lang=js&"
import style0 from "./Covid.vue?vue&type=style&index=0&id=9bdf6730&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports